export default __webpack_public_path__ + "static/Icon-hand-globe-5dfeaad0926641875911e6cc9771cd7c.svg";